/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from 'react';
import Slider from 'react-slick';
import MediaGalleryItem from '@components/MediaGallery/MediaGalleryItem';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './index.scss';

/**
 * Takes page data and renders a Media Gallery
 * of gallery images and/or content cards.
 */
const MediaGallery = ({ page }) => {
  const numberOfEntries = page.mediaGallery.length;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: numberOfEntries < 4 ? 4 - (4 - numberOfEntries) : 4,
    slidesToScroll: 4,
    arrows: false,
    className: 'slider-style',
    dotsClass: 'slick-dots',
  };

  const mobileSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    className: 'slider-style',
    dotsClass: 'slick-dots',
  };

  return (
    <>
      <div id="desktop-view" style={{ background: 'rgb(60, 56, 56)', height: '375px', paddingTop: '15px' }}>
        <div style={{ width: '90%', margin: '0 auto' }}>
          <Slider {...settings}>
            {page.mediaGallery.map((card) => (
              <MediaGalleryItem card={card} key={card} />
            ))}
          </Slider>
        </div>
      </div>
      <div id="mobile-view" style={{ background: 'rgb(60, 56, 56)', height: '400px', paddingTop: '15px' }}>
        <div style={{ width: '90%', margin: '0 auto' }}>
          <Slider {...mobileSettings}>
            {page.mediaGallery.map((card) => (
              <MediaGalleryItem card={card} key={card} />
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default MediaGallery;
